import { generateClient } from "aws-amplify/api";
import { listAdminUsers } from "@/graphql/mutations";
const client = generateClient();
export const GetAllAdmins = {
  methods: {
    async GetAllAdminsMethod() {
      try {
        this.loading = true;
        let result = await client.graphql({
          query: listAdminUsers,
          variables: {
            input: {
              user_id: this.$store.getters.get_current_user_details.user_id,
              user_status: "ACTIVE",
            },
          },
        });

        var ResultObj = JSON.parse(result.data.listAdminUsers);
        if (ResultObj.status == 200 || ResultObj.status === "SUCCESS") {
          this.GetAllAdminsList = ResultObj.data.items;
        }
        this.loading = false;
      } catch (error) {
        this.GetAllAdminsList = [];
        this.loading = false
        console.log("Error", error);
      }
    },
  },
};
